var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"fallback-container"},[_vm._t("default",[_c('h1',[_vm._v("Fallback.vue")])])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }